import ErrorPage from 'components/ErrorPage';
import { useModuleRouter } from 'hooks/useModuleRouter';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';
import { ROUTE_HOME } from 'utils/routes';

const MODULES_PRIORITIES: Record<string, number> = {
  Cockpit: 1,
  Briefing: 2,
  PathToGrowth: 3,
  Audience: 4,
  Inspire: 5,
  Planning: 6,
  Activation: 7,
  OptimizeAndReport: 8,
  Config: 9,
  CampaignMonitor: 10,
};

const getModuleRoute = (moduleNameFromPermissions: string) =>
  moduleNameFromPermissions === 'Cockpit' ? ROUTE_HOME : `/${moduleNameFromPermissions}`;

export const HomePage = () => {
  const permissionsMatrix = useModuleRouter();
  const { t } = useTranslation();

  const accessibleModules = useMemo(() => {
    return Object.keys(MODULES_PRIORITIES)
      .filter((module) => permissionsMatrix.includes(module))
      .sort((a, b) => MODULES_PRIORITIES[a] - MODULES_PRIORITIES[b]);
  }, [permissionsMatrix]);

  if (!accessibleModules.length)
    return <ErrorPage headerText={t('NotFound')} bodyText={t('ErrorMessage')} />;

  // Redirect the user to the highest priority accessible module
  return <Redirect to={getModuleRoute(accessibleModules[0])} />;
};
